import { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const consented = localStorage.getItem('cookie-consent');
    if (!consented) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setExiting(true);
    setTimeout(() => setVisible(false), 400);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[90] transition-all duration-400 ${
        exiting ? 'translate-y-full opacity-0' : 'translate-y-0 opacity-100'
      }`}
    >
      <div className="bg-foreground-950/95 backdrop-blur-md border-t border-foreground-800/60">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-3 md:py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/20 flex-shrink-0 mt-0.5">
              <i className="ri-shield-check-line text-primary-400 text-sm"></i>
            </div>
            <p className="text-[13px] sm:text-sm text-foreground-300 leading-snug sm:leading-relaxed max-w-2xl">
              Ta spletna stran uporablja piškotke za zagotavljanje boljše uporabniške izkušnje. Z nadaljnjo uporabo se strinjate z uporabo piškotkov.{' '}
              <a href="#" className="text-primary-400 hover:text-primary-300 underline underline-offset-2 transition-colors">
                Več informacij
              </a>
            </p>
          </div>
          <div className="flex items-center gap-2.5 w-full sm:w-auto flex-shrink-0">
            <button
              onClick={accept}
              className="whitespace-nowrap w-full sm:w-auto text-center px-6 py-2.5 rounded-md bg-primary-500 text-foreground-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
            >
              Sprejmem
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}